import axiosClient from './axiosClient';

const rideDriverApi = {
  getDrivers: (params) => axiosClient.get('/rides/drivers', { params }),
  getDriver: (driverProfileId) => axiosClient.get(`/rides/drivers/${driverProfileId}`),
  getDriverTrips: (driverProfileId, params) => axiosClient.get(`/rides/drivers/${driverProfileId}/trips`, { params }),
  setAccountLock: (driverProfileId, locked) => axiosClient.post(`/rides/drivers/${driverProfileId}/account-lock`, { locked }),
  reactivateProfile: (driverProfileId) => axiosClient.post(`/rides/drivers/${driverProfileId}/reactivate-profile`),
};

export default rideDriverApi;
